import React, { useState, useEffect } from "react";
import { TextField, Link } from "@mui/material";
import { StyleUtils } from "../../app/utils/styleUtils";
import { setFieldValue } from "../MainContent/MainContentUtils";
import { useAppSelector } from "../../app/hooks";
import { GridRenderCellParams } from "@mui/x-data-grid";
import { showWarning } from "../../app/utils/validationUtils";

/* Functional component properties */
interface Props {
  classes: any;
  item: any;
  isGridElem: boolean;
  setWidth: string;
  clear: string;
  setClear: (clr: string) => void;
  handler: (link: GridRenderCellParams) => void;
  buttonClickHandler: (btn: any) => void;
}

/* React Functional component */
export const Field: React.FC<Props> = ({
  /* Function arguments (Props) */
  classes,
  item,
  isGridElem,
  setWidth,
  clear,
  setClear,
  handler,
  buttonClickHandler,
}): JSX.Element => {
  /* get state */
  const state = useAppSelector((state) => state);

  const [val, setVal] = useState(item.value ? item.value : "");
  const [isUpdated, setIsUpdated] = useState<boolean>(false);

  /* commented because it is giving flicker issue in fields(getting updated twice) */
  /* if commented then data grid not gettin updated */
  useEffect(() => {
    if (item.value !== val && !isUpdated) {
      setVal(item.value);
    }
  }, [item]);

  useEffect(() => {
    // Set value in redux store mainContent.fieldList
    if (item.value !== val) {
      if (isGridElem) setFieldValue(item.field, val, item.id);
      else setFieldValue(item.name, val);
    }
  }, [val]);

  useEffect(() => {
    if (
      clear === "true" &&
      item.editable &&
      item.editable === "true" &&
      val !== ""
    ) {
      setClear("false");
      setVal("");
    } else if (clear === "true") {
      setClear("false");
    }
  });

  // function handleMouseLeave(
  //   event: React.MouseEvent<HTMLDivElement, MouseEvent>
  // ) {
  //   if (item.value !== val)
  //     setFieldValue(item.name, (event.target as HTMLInputElement).value); // Set value in redux store mainContent.fieldList
  // }

  // function onBlur(
  //   event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  // ) {
  //   setFieldValue(item.name, event.target.value); // Set value in redux store mainContent.fieldList
  // }

  function handleChange(
    event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) {
    setIsUpdated(true);

    if (isGridElem) {
      if (item.field.substr(0, 1) !== "F") {
        window.myGlobalVar.pendingChanges.status = true; // Set pending changes
        if (
          window.myGlobalVar.pendingChanges.items.indexOf(
            `${item.field + "(" + item.id + ")"}`
          ) === -1
        )
          window.myGlobalVar.pendingChanges.items.push(
            `${item.field + "(" + item.id + ")"}`
          );
        window.myGlobalVar.pendingChanges.showWarning = false;
      }
    } else {
      if (item.name.substr(0, 1) !== "F") {
        window.myGlobalVar.pendingChanges.status = true; // Set pending changes

        if (window.myGlobalVar.pendingChanges.items.indexOf(item.name) === -1)
          window.myGlobalVar.pendingChanges.items.push(item.name);
        window.myGlobalVar.pendingChanges.showWarning = false;
      }
    }

    setVal(event.target.value); // Set local state value in useState
  }

  return isGridElem === true ? (
    item.colDef.canEdit && item.colDef.canEdit === true ? ( // If it is a grid field and editable
      <TextField
        // {...(showWarning(item.field, item.id) ? { color: "warning" } : {})} //Modified Fields
        // {...(showWarning(item.field, item.id)
        //   ? { focussed: "true" }
        //   : { focussed: "false" })} //Modified Fields
        variant="outlined"
        key={item.field + "(" + item.id + ")"}
        id={item.field + "(" + item.id + ")"}
        value={val}
        onChange={(e) => handleChange(e)}
        inputProps={{
          maxLength: item.colDef.length ? item.colDef.length : "", // Max input length
        }}
        error={
          (state.mainContent.messageList.length > 0 &&
            state.mainContent.messageList.find(
              (msg) =>
                msg.fields !== undefined &&
                msg.fields?.indexOf(item.field + "(" + item.id + ")") >= 0
            ) !== undefined) ||
          showWarning(item.field, item.id)
        }
      />
    ) : // If it is a grid field and non-editable
    item.colDef.clickable !== undefined && item.colDef.clickable === "true" ? (
      <Link
        onClick={(e) => handler(item)} //TODO
        key={item.field + "(" + item.id + ")"}
        id={item.field + "(" + item.id + ")"}
      >
        {val}
      </Link>
    ) : (
      <div className={classes.plainText}>{val}</div>
    )
  ) : // If it is an invidual field
  item.clickable && item.clickable === "true" ? (
    <Link
      onClick={(e) => buttonClickHandler(item)} //TODO
      key={item.name}
      id={item.name}
    >
      {item.value}
    </Link>
  ) : (
    <TextField
      // {...(showWarning(item.name) ? { color: "warning" } : {})} //Modified Fields
      // {...(showWarning(item.name)
      //   ? { focussed: "true" }
      //   : { focussed: "false" })} //Modified Fields
      {...(item.editable && item.editable === "true" ? {} : { disabled: true })} //Disabled Fields
      className={
        item.visible && item.visible === "false" ? classes.hiddenField : "" //Hidden Fields
      }
      variant="outlined"
      label={item.label}
      key={item.name}
      name={item.name}
      id={item.name}
      value={val}
      onChange={(e) => handleChange(e)}
      inputProps={{
        maxLength: item.length ? item.length : "", // Max input length
      }}
      error={
        (state.mainContent.messageList.length > 0 &&
          state.mainContent.messageList.find(
            (msg) =>
              msg.fields !== undefined && msg.fields?.indexOf(item.name) >= 0
          ) !== undefined) ||
        showWarning(item.name)
      }
      helperText={
        state.mainContent.messageList.length > 0 &&
        state.mainContent.messageList.find(
          (msg) =>
            msg.fields !== undefined && msg.fields?.indexOf(item.name) >= 0
        ) !== undefined
          ? "Error"
          : ""
      }
      style={
        setWidth === "true"
          ? {
              width: `${(() => StyleUtils.getWidth(item))()}px`, // Calculating width of the field
            }
          : {}
      }
    />
  );
};
